import { render, staticRenderFns } from "./registerLayout.vue?vue&type=template&id=4f63842f&scoped=true&"
import script from "./registerLayout.vue?vue&type=script&lang=js&"
export * from "./registerLayout.vue?vue&type=script&lang=js&"
import style0 from "./registerLayout.vue?vue&type=style&index=0&id=4f63842f&scoped=true&lang=css&"
import style1 from "./registerLayout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f63842f",
  null
  
)

export default component.exports